import { Modal } from "antd";

export const alertError = (message) => {
  Modal.error({
    title: "An Error Occured",
    content: message,
  });
};

export const alertSuccess = (message) => {
  Modal.success({ content: message });
};

export const normalModal = (title, content,onSubmit) => {
  Modal.info({
    title: title,
    content: <div>{content}</div>,
    okText:"Submit",
    onOk() {onSubmit()},
  });
};
